import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/machine/model`,
    name: 'MACHINE_MODEL_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
